import { assign } from "xstate";

const state: any = {
	id: "interstitial",
	initial: "waiting",
	context: {
		interstitialReady: false,
		uploadInProgress: false,
		error: null, // "server" | "url" | "pitcher"| "timeout"; // pitcher probably wont fire here
	},
	states: {
		waiting: {
			always: {
				cond: "isMockFail",
				target: "failed",
				actions: ["interstitialReady", "uploadUrlError"],
			},
			on: {
				SUBMIT_BUILDER: {
					target: "uploadInProgress",
					actions: ["interstitialReady", "setUploadInProgress"], // context update
				},
			},
		},
		uploadInProgress: {
			on: {
				UPLOAD_SUCCESS: {
					target: "successful",
				},
				UPLOAD_TIMEOUT: {
					target: "failed",
					actions: ["uploadTimedOut"],
				},
				UPLOAD_SERVER_ERROR: {
					target: "failed",
					actions: ["uploadServerError"],
				},
				UPLOAD_URL_ERROR: {
					target: "failed",
					actions: ["uploadUrlError"],
				},
			},
		},

		successful: {
			after: { 3000: { target: "reset" } },
		},

		failed: {
			on: {
				// If the upload succeeded despite an earlier error signal (e.g. transient
				// publishUrlError that was overwritten by publishUrl), recover gracefully.
				// clearError removes the PublishFail modal immediately on recovery.
				UPLOAD_SUCCESS: {
					target: "successful",
					actions: ["clearError"],
				},
				START_OVER_CLICKED: {
					target: "backToBuilder",
				},
				CANCEL_CLICKED: {
					target: "backToManager",
				},
			},
		},
		backToManager: {
			always: { target: "reset" },
		},

		backToBuilder: {
			always: {
				target: "complete",
				actions: ["resetContext"],
			},
		},

		reset: {
			always: {
				target: "complete",
				actions: ["resetContext", "redirectToManager"],
			},
		},

		complete: {
			always: [
				{ target: "uploadInProgress", cond: "isMockFail" }, // For now, no reset logic
				{ target: "waiting", cond: "isDefault" },
			],
		},
	},
};

const interstitialReady = assign({
	interstitialReady: () => true,
});

const setUploadInProgress = assign({
	uploadInProgress: () => true,
});

const resetContext = assign({
	uploadInProgress: () => false,
	interstitialReady: () => false,
	error: () => null,
});

// TODO: Add Pitcher on relevant ticket
const uploadTimedOut = assign({
	error: () => "timeout",
});

const uploadServerError = assign({
	error: () => "server",
});

const uploadUrlError = assign({
	error: () => "url",
});

const clearError = assign({
	error: () => null,
});

const events: any = {
	actions: {
		interstitialReady,
		setUploadInProgress,
		resetContext,
		uploadTimedOut,
		uploadServerError,
		uploadUrlError,
		clearError,
	},
};

const config = {
	state,
	events,
};

export default config;
